import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import Datamap from 'datamaps';
import template from '@/../templates/dashboard/widgets/map.hbs';
import device_stream from '@/collections/v5/devicegroup_devices_logstream';
import europe from '@/lib/data/eu.topo.js';

    /*
     *  map_heights object of pixel height maps per width in columns
     *
     *  ex: a module with options.columns = 2
     *  would find its height this way map_heights[this.options.columns]
     */
    var map_heights = { 4 :135, 6 : 165, 12: 405 };

    var RegionSelect = new Marionette.View();

    var Map = Marionette.View.extend(LayoutMixin).extend({
        className: function(){ return "widget map " + this.getWidth(); },
        template: Handlebars.compile(template),
        childView: RegionSelect,
        bubbles: [], // datamap plugin for connection data points
        ui: {
            'map' : '.map',
            'dropdown' : '.region-selector',
            'dropdown_title' : '.region-selector .title',
            'scope_world': '#scope-world',
            'scope_usa': '#scope-usa',
            'scope_europe': '#scope-europe',
        },
        events: {
            'click @ui.scope_world': 'select_scope',
            'click @ui.scope_usa': 'select_scope',
            'click @ui.scope_europe': 'select_scope',
        },
        collectionEvents: {
            'update': 'render'
        },
        initialize: function() {
            // clear device connection on init then start it
            device_stream.disconnect();
            this.start_device_stream(this.model);
        },
        onAttach: function() {
            // Initial setup after DOM elements are attached
            var options = {
                scope: 'world' // default scope
            };
            // Initially selected map
            this.ui.scope_world.addClass('disabled');
            this.setup_map(options);
        },
        select_scope(e) {
            // If we have no scope, break and leave the current map
            var scope = $(e.currentTarget).data('scope');
            if (!scope) {
                return;
            }
            this.empty_map();
            this.$el.find('.scope-item').removeClass('disabled');
            $(e.currentTarget).addClass('disabled');

            switch (scope) {
                case 'usa':
                    this.ui.dropdown_title.text('USA');
                    break;
                case 'world':
                    this.ui.dropdown_title.text('World');
                    break;
                case 'europe':
                    this.ui.dropdown_title.text('Europe');
                    break;
                default:
                    break;
            }

            // Europe has a special configuration
            if (scope === 'europe') {
                this.setup_europe();
            } else {
                this.setup_map({
                    scope: scope
                });
            }
        },
        setup_europe: function(options) {
            var self = this;
            options = options || {};

            var europe_options = {
                element: this.ui.map[0],
                height: map_heights[this.options.columns],
                width: this.ui.map.width() * .75,
                scope: 'europe',
                geographyConfig: {
                    popupOnHover: true,
                    highlightOnHover: true,
                    dataJson: europe
                },
                fills: {
                    defaultFill: '#c6c8ca',
                    blue_fill: '#21abd4',
                    red_fill: '#CC4403'
                },
                bubblesConfig: {
                    popupOnHover: true,
                    popupTemplate: function (geography, data) {
                        return ['<div class="hoverinfo">',
                            'latitude: ' + data.latitude,
                            '<br/>longitude: ' + data.longitude,
                            '</div>'].join('');
                    }
                },
                setProjection: function (element) {
                    var projection = window.d3.geo.mercator()
                        .center([14, 50]) // always in [East Latitude, North Longitude]
                        .scale(450);
                    var path = window.d3.geo.path().projection(projection);
                    return { path: path, projection: projection };
                }
            };

            _.extend(europe, options);

            this._map = new Datamap(europe_options);
            this.load_map_data();
            window.addEventListener('resize', function () {
                self._map.resize();
            });
        },
        setup_map: function(options) {
            var self = this;
            options = options || {};
            
            var default_options = {
                geographyConfig: {
                    popupOnHover: true,
                    highlightOnHover: true
                },
                element: this.ui.map[0],    
                height: map_heights[this.options.columns],
                width: this.ui.map.width() * .75,
                scope: options.scope || 'world',
                projection: 'mercator',
                fills: {
                    defaultFill: '#c6c8ca',
                    blue_fill: '#21abd4',
                    red_fill: '#CC4403'
                },
                bubblesConfig: {
                    popupOnHover: true,
                    popupTemplate: function (geography, data) {
                        return ['<div class="hoverinfo">',
                            'latitude: ' + data.latitude,
                            '<br/>longitude: ' + data.longitude,
                            '</div>'].join('');
                    }
                },
            };

            _.extend(default_options, options);

            this._map = new Datamap(default_options);
            this.load_map_data();
            window.addEventListener('resize', function(){
                self._map.resize();
            });
        },
        templateContext: function() {

            var strings = {
                title   : "Device Connections",
            };

            return {
                s : strings,
                width : this.getWidth(),

            };
        },
        onDestroy: function() {
            // Incredibly, Backbone/Marionette doesn't have destroyed views stop listening for events. 
            // Need to do this manually to prevent logs from being added to the collection from destroyed views.
            this.stopListening();
        },
        start_device_stream: function(dg){
            this.bubbles = [];
            this.listenTo(device_stream, 'connection_stream', function(connection) {
                var id = this.llToId(connection);
                var item = {
                    id: id,
                    name: 'test device',
                    radius: 5,
                    fillKey: 'blue_fill',
                    longitude: connection[0],
                    latitude: connection[1],
                    borderWidth: 0,
                    ts: Date.now(),
                };

                if (_.where(this.bubbles, {id: id}).length > 0) {
                    return;
                }
                
                this.bubbles.push(item);

                this.load_map_data();
            });
            
            device_stream.add(dg);
        },
        // Create an id so as not to show a lot of points in the same general area
        llToId: function(ll) {
            return `i${Math.floor(ll[0] * 10000)}${Math.floor(ll[1] * 10000)}`;
        },
        empty_connections: function() {
            this.bubbles = [];
        },
        empty_map: function() {
            this.ui.map.empty();
            return;
        },
        load_map_data: function() {
            this._map.bubbles(this.bubbles);
        },

    });

    export default Map;


